import { WriterReport } from './WriterReport'
import { withWriterReport } from './withWriterReport'

const ConnectedWriterReport = withWriterReport(WriterReport)

export { ConnectedWriterReport as WriterReport }
